import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { RealizacjeProvider } from './Context/RealizacjeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <RealizacjeProvider>
        <App />
      </RealizacjeProvider>
    </BrowserRouter>
  </React.StrictMode>
);


